export var convertToUpdateDto = function (data) {
    var _a;
    var dtoData = {
        username: data.username,
        avatar: (_a = data.avatar) === null || _a === void 0 ? void 0 : _a.id,
    };
    return dtoData;
};
